import * as types from './actionTypes'

export const createEmailTemplate = (data) => ({
    type: types.EMAIL_TEMPLATE_CREATE,
    data
})

export const createEmailTemplateSuccess = () => ({
    type: types.EMAIL_TEMPLATE_CREATE_SUCCESS
})

export const createEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_CREATE_FAILED
})

export const deleteEmailTemplate = (id) => ({
    type: types.EMAIL_TEMPLATE_DELETE,
    id
})

export const deleteEmailTemplateSuccess = () => ({
    type: types.EMAIL_TEMPLATE_DELETE_SUCCESS
})

export const deleteEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_DELETE_FAILED
})

export const updateEmailTemplate = (data) => ({
    type: types.EMAIL_TEMPLATE_UPDATE,
    data
})

export const updateEmailTemplateSuccess = () => ({
    type: types.EMAIL_TEMPLATE_UPDATE_SUCCESS
})

export const updateEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_UPDATE_SUCCESS
})

export const resetEmailTemplate = () => ({
    type: types.EMAIL_TEMPLATE_RESET
})

export const sendEmailTemplate = (template, documents, save, test) => ({
    type: types.EMAIL_TEMPLATE_SEND,
    template,
    documents,
    save,
    test
})

export const sendEmailTemplateSuccess = (result, test) => ({
    type: types.EMAIL_TEMPLATE_SEND_SUCCESS,
    result,
    test
})

export const sendEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_SEND_FAILED
})

export const getEmailTemplate = (id) => ({
    type: types.EMAIL_TEMPLATE_FETCH,
    id
})

export const getEmailTemplateSuccess = (template) => ({
    type: types.EMAIL_TEMPLATE_FETCH_SUCCESS,
    template
})

export const getEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_FETCH_FAILED
})

export const getSignatures = (application) => ({
    type: types.SIGNATURES_FETCH,
    application
})

export const getSignaturesSuccess = (signatures, application) => ({
    type: types.SIGNATURES_FETCH_SUCCESS,
    signatures,
    application
})

export const getSignaturesFailed = () => ({
    type: types.SIGNATURES_FETCH_FAILED
})

export const updateSignature = (obj, application) => ({
    type: types.SIGNATURE_UPDATE,
    obj,
    application
})

export const updateSignatureSuccess = (signature, application) => ({
    type: types.SIGNATURE_UPDATE_SUCCESS,
    signature,
    application
})

export const updateSignatureFailed = () => ({
    type: types.SIGNATURE_UPDATE_FAILED
})

export const deleteSignature = (id, application) => ({
    type: types.SIGNATURE_DELETE,
    id,
    application
})

export const deleteSignatureSuccess = (signature, application) => ({
    type: types.SIGNATURE_DELETE_SUCCESS,
    signature,
    application
})

export const deleteSignatureFailed = () => ({
    type: types.SIGNATURE_DELETE_FAILED
})

export const createSignature = (obj, application) => ({
    type: types.SIGNATURE_CREATE,
    obj,
    application
})

export const createSignatureSuccess = (signature, application) => ({
    type: types.SIGNATURE_CREATE_SUCCESS,
    signature,
    application
})

export const createSignatureFailed = () => ({
    type: types.SIGNATURE_CREATE_FAILED
})

export const cloneEmailTemplate = (id) => ({
    type: types.EMAIL_TEMPLATE_CLONE,
    id
})

export const cloneEmailTemplateSuccess = (duplicate) => ({
    type: types.EMAIL_TEMPLATE_CLONE_SUCCESS,
	duplicate
})

export const cloneEmailTemplateFailed = () => ({
    type: types.EMAIL_TEMPLATE_CLONE_FAILED
})

export const setEmailTemplatesOrder = (entity, order) => ({
    type: types.SET_EMAIL_TEMPLATES_ORDER,
    entity,
    order
})
